module.exports = __webpack_public_path__ + "img/logo.6c92a49c.png";